import {
  Box,
  Button,
  Checkbox,
  Flex,
  Popover,
  PopoverBody,
  PopoverContent,
  PopoverTrigger,
  Text,
  Spinner,
  Wrap,
  WrapItem,
} from "@chakra-ui/react";
import { ChevronDownIcon } from "@chakra-ui/icons";

const DISPLAY_LIMIT = 8;

export default function TagFilterSelect({
  tags = [],
  selectedIds = [],
  onChange,
  onClearAll,
  isLoading = false,
}) {
  const isSelected = (id) => selectedIds.includes(id);
  const hasSelection = selectedIds.length > 0;

  const handleToggle = (tagId) => {
    const next = isSelected(tagId)
      ? selectedIds.filter((id) => id !== tagId)
      : [...selectedIds, tagId];
    onChange(next);
  };

  return (
    <Flex align="center" gap="8px" flexWrap="wrap">
      <Text fontSize="14px" fontWeight={600} color="gray.600" mr="4px">
        태그:
      </Text>
      <Button
        size="sm"
        variant={!hasSelection ? "solid" : "outline"}
        colorScheme="blue"
        onClick={onClearAll}
      >
        전체
      </Button>

      {isLoading ? (
        <Spinner size="sm" />
      ) : tags.length === 0 ? null : (
        <Popover placement="bottom-start" isLazy>
          <PopoverTrigger>
            <Button
              size="sm"
              variant="outline"
              colorScheme="blue"
              rightIcon={<ChevronDownIcon />}
            >
              {hasSelection
                ? `선택됨 ${selectedIds.length}개`
                : `태그 선택 (${tags.length}개)`}
            </Button>
          </PopoverTrigger>
          <PopoverContent w="320px" maxH="320px" _focus={{ boxShadow: "md" }}>
            <PopoverBody p="12px">
              <Box maxH="280px" overflowY="auto" pr="4px">
                <Flex flexDir="column" gap="4px">
                  {tags.map((tag) => (
                    <Checkbox
                      key={tag.id}
                      isChecked={isSelected(tag.id)}
                      onChange={() => handleToggle(tag.id)}
                      colorScheme="blue"
                    >
                      #{tag.tagName}
                    </Checkbox>
                  ))}
                </Flex>
              </Box>
            </PopoverBody>
          </PopoverContent>
        </Popover>
      )}

      {hasSelection && (
        <Wrap spacing="4px" maxW="100%">
          {tags
            .filter((t) => selectedIds.includes(t.id))
            .slice(0, DISPLAY_LIMIT)
            .map((t) => (
              <WrapItem key={t.id}>
                <Button
                  size="xs"
                  colorScheme="blue"
                  variant="solid"
                  onClick={() => handleToggle(t.id)}
                >
                  #{t.tagName} ×
                </Button>
              </WrapItem>
            ))}
          {selectedIds.length > DISPLAY_LIMIT && (
            <WrapItem>
              <Text fontSize="xs" color="gray.500" alignSelf="center">
                +{selectedIds.length - DISPLAY_LIMIT}개
              </Text>
            </WrapItem>
          )}
        </Wrap>
      )}
    </Flex>
  );
}
